import script from "./WebRtcUserDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebRtcUserDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./WebRtcUserDisplay.vue?vue&type=style&index=0&id=0de708ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de708ee"]])

export default __exports__